<template>
    <div class="users-style" >
        <table class="table table-sticky">
           <thead>
                <tr class="table-head">                    
                    <th>Company</th>
                    <th v-for="user in users" :key="user.id" v-if="user.user_level > 2">
                        {{user.name}}<br />
                        [{{show_user_level[user.user_level].text}}] <template v-if="user.rootuser == 1">*</template>
                    </th>
                </tr>
            </thead>
            <tbody>
                
                <template class="hover-bg table-row" v-for="(agent , n) in agents" >
                    
                    <tr class="hover-bg table-row" v-for="company in agent.companies" :key="company.value">                        
                        <td>{{agent.name}} - {{company.text}}</td>
                        <td v-for="user in users" :key="user.id" v-if="user.user_level > 2">
                            <template v-if="user.user_level < 3">
                                <b-form-checkbox disabled :indeterminate.sync="indeterminate">                       
                                </b-form-checkbox>
                            </template>
                            <template v-else>
                                <b-form-checkbox v-model="assigned_users[user.id][company.value]" @change="assignUser(user.id , company.value)"  >{{company.id}}</b-form-checkbox>
                            </template>
                        </td>
                    </tr>
                </template>
                
                
                
            </tbody>
        </table>

        <br />

        
    </div>

</template>

<script>
    export default{
        
        mounted() {
           
        },
        props: [],
        data(){            
            
            return {
                
                users : [],
                agents : [],
                assigned_users : [],
                                
                blankmsg : 'Fetching data..',
                
                show_user_level: [
                    { value: "0", text: "Select..." },
                    { value: "1", text: "Super Admin" },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Officer" },
                ],

                checked: true,
                indeterminate: true,
                                
            }
        },
        methods:{
            assignUser :function(user_id , company_id)
            {
                let flg = 0;

                if(this.assigned_users[user_id][company_id]) flg=1;
                //alert(this.assigned_users[user_id][company_id]);
                
                let currentObj = this;
                
                let formData = new FormData();                    
                formData.append('user_id', user_id);
                formData.append('company_id', company_id);
                formData.append('flg', flg);

                axios.post(this.$api_url+'/system/assigned-users', formData)
                            .then(function (response) 
                            {
                                                    

                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });

                                
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.serverError(error);
                                currentObj.errormsg = error.response.data.errors;                                    
                            });
            },
            getSystemUsers: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/all-admin-user' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.users = response.data;
                    if(this.users.length == 0)
                        this.blankmsg = "Nothing found.";
                        
                }.bind(this)).catch(function (error){this.serverError(error);});
            },    
            getCompanies: function(){
              axios.get(this.$api_url+'/companies/all')
              .then(function (response) {
                    this.agents = response.data;                    
              }.bind(this));
         
            },
            getAssignedUsers: function(){
              axios.get(this.$api_url+'/system/assigned-users')
              .then(function (response) {
                    this.assigned_users = response.data;
                    //console.log(this.assigned_users);
              }.bind(this));
         
            },

        },
        created: function(){
            this.getSystemUsers();
            this.getCompanies();
            this.getAssignedUsers();
            
        },
    }
</script>